export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const REMOVE_NOTIFICATIONS = 'REMOVE_NOTIFICATIONS';

export const NOTIFICATION_TYPE = {
    SUCCESS: 'success',
    ERROR: 'error',
};
